import { APP_PRIVATE_PATHS } from '@epicuro-next/navigation/constants';

export const isSearchUrl = urlIncludesPath(APP_PRIVATE_PATHS.search.path);
export const isListUrl = urlIncludesPath(APP_PRIVATE_PATHS.productList.path);
export const isLookbookUrl = urlIncludesPath(
  APP_PRIVATE_PATHS.shopTheLook.path,
);

function urlIncludesPath(path: string) {
  return (url: string): boolean => url.includes(path);
}

export function getListIdFromProductListUrl(url: string): string {
  const urlBeforeId = new RegExp(`.*${APP_PRIVATE_PATHS.productList.path}/`);
  const listId = url.replace(urlBeforeId, '').split('/')[0];
  return listId ?? '';
}
